import 'config/environment';
import 'core-js/features/object/from-entries';
import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import 'react-datepicker/dist/react-datepicker.css';
import { getEnvironment } from '@minecraft.environment';
import { initObservability } from '@blocs.observability';
import { initBraze } from '@blocs.braze';
import { RouteProvider, createHistory } from '@blocs.router';
import { initUxTracking } from '@blocs.uxTracking';
import App from './App';

const environment = getEnvironment();
const history = createHistory();

initObservability({ history });
initBraze().initializeInAppMessaging();
initUxTracking();

TagManager.initialize({
  gtmId: environment.GOOGLE_TAG_MANAGER_ID,
  auth: environment.GOOGLE_TAG_MANAGER_ENVIRONMENT_AUTH,
  preview: environment.GOOGLE_TAG_MANAGER_ENVIRONMENT_PREVIEW,
});

ReactDOM.render(
  <RouteProvider history={history}>
    <App />
  </RouteProvider>,
  document.getElementById('app')
);
